<div>

  @if (notification.type !== 'AUTO_ORDERS') {
    <div>
      <app-notification
        [setNotification]="notification"
        [setUserStores]="userStores"
        [setUser]="user">
      </app-notification>
    </div>
  }

  <div
    class="notification-extra"
    [class.notification-extra-attached]="notification.type !== 'AUTO_ORDERS' && !notification.success"
    [class.notification-extra-failed]="notification.type === 'AUTO_ORDERS' && !notification.success">
    @switch (notification.type) {
      @case ('AUTO_ORDERS') {
        <app-notification-type-auto-order
          [setUser]="user"
          [setUserStores]="userStores"
          [setAutoOrders]="(notificationAutoOrders$ | ngrxPush)"
          [setIsAutoOrderLoading]="(isNotificationAutoOrderLoading$ | ngrxPush)"
          [setNotification]="notification">
        </app-notification-type-auto-order>
      } @case ('STOCK_UPDATE') {
        <app-notification-type-stock-update
          [setIsStockUpdateLoading]="(isNotificationStockUpdateLoading$ | ngrxPush)"
          [setNotification]="(notification)">
        </app-notification-type-stock-update>
      } @case ('STOCK_TAKE') {
        <app-notification-type-stock-take
          [setNotification]="notification">
        </app-notification-type-stock-take>
      } @case ('QUOTES') {
        <app-notification-type-quotes
          [setNotification]="notification">
        </app-notification-type-quotes>
      }
    }

  </div>

</div>
